import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'doc-table-pagination',
  standalone: true,
  imports: [CommonModule, FormsModule, NgbPaginationModule, TranslateModule],
  template: `
    <div class="doc-table-pagination d-flex flex-wrap justify-content-between align-items-center gap-2">
      @if (showPageSize) {
        <div class="d-flex align-items-center gap-2">
          <label class="text-muted small mb-0">
            {{ rowsPerPageLabel || ('Pagination.RowsPerPage' | translate) }}
          </label>
          <select
            class="form-select form-select-sm doc-table-pagination__size"
            [ngModel]="pageSize"
            (ngModelChange)="onPageSizeChange($event)">
            @for (size of pageSizeOptions; track size) {
              <option [ngValue]="size">{{ size }}</option>
            }
          </select>
        </div>
      }

      <ngb-pagination
        [collectionSize]="total"
        [page]="page"
        [pageSize]="pageSize"
        [maxSize]="maxSize"
        [rotate]="true"
        [boundaryLinks]="showBoundaryLinks"
        (pageChange)="pageChange.emit($event)">
      </ngb-pagination>
    </div>
  `,
  styles: `
    .doc-table-pagination__size {
      width: auto;
      min-width: 4.5rem;
    }
  `,
})
export class DocTablePaginationComponent {
  @Input() total = 0;
  @Input() page = 1;
  @Input() pageSize = 10;
  @Input() pageSizeOptions: number[] = [5, 10, 25, 50];
  @Input() maxSize = 5;
  @Input() showBoundaryLinks = true;
  @Input() showPageSize = true;
  @Input() rowsPerPageLabel = '';

  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();

  onPageSizeChange(size: number): void {
    this.pageSizeChange.emit(Number(size));
  }
}
